import { createPlatformQueryClient } from "@gtm-agents/gtm-ui";

export const queryClient = createPlatformQueryClient();
